const QUERY_KEYS = {
  CURRENT_USER: "current-user",
  USER: "user",
  MATCHES: "matches",
  CHATS: "chats",
  MESSAGES: "messages",
  DISCOVERY_USERS: "discovery-users",
} as const;

export default QUERY_KEYS;

/**
 * Feature-specific query keys for centralized management
 */

/**
 * Matches query keys
 */
export const matchesQueryKeys = {
  all: [QUERY_KEYS.MATCHES] as const,
  allMatches: (uid: string) => [...QUERY_KEYS.MATCHES, "all", uid] as const,
};

/**
 * Chats query keys
 */
export const chatsQueryKeys = {
  all: [QUERY_KEYS.CHATS] as const,
  user: (uid: string) => [...QUERY_KEYS.CHATS, "user", uid] as const,
  chat: (chatId: string) => [...QUERY_KEYS.CHATS, "chat", chatId] as const,
};

/**
 * Messages query keys
 */
export const messagesQueryKeys = {
  all: [QUERY_KEYS.MESSAGES] as const,
  chat: (chatId: string) => [...QUERY_KEYS.MESSAGES, "chat", chatId] as const,
};

/**
 * Discovery query keys
 */
export const discoveryQueryKeys = {
  all: [QUERY_KEYS.DISCOVERY_USERS] as const,
  users: (uid: string) => [...QUERY_KEYS.DISCOVERY_USERS, "users", uid] as const,
};

/**
 * User by id (for match profile, etc.)
 */
export const userQueryKeys = {
  user: (uid: string) => [QUERY_KEYS.USER, uid] as const,
};
